module.exports = __webpack_public_path__ + "static/media/academyofsingapore.b6db8ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/academyofsingapore.png
// module id = 1168
// module chunks = 0